module.exports = __webpack_public_path__ + "static/img/Purchased.1e15806.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Purchased.png
// module id = 8PT/
// module chunks = 1